import { Box, Grid, Typography } from "@mui/material";

import parametricEQImage from "../../../static/images/distant_amp/parametric-eq.png";

const EQ_FEATURES = [
  {
    title: "Analog and digital modes",
    description: "Switch between analog and digital modes to change the shape of the EQ curves.",
  },
  {
    title: "Auto gain and flexible routing",
    description: "Use auto gain and choose whether the EQ processes the plugin's input or output.",
  },
  {
    title: "Dynamic bands",
    description: "Set bands to dynamically cut or boost selected frequencies in response to your signal.",
  },
];

const ParametricEQ = () => {
  return (
    <Box
      component="section"
      aria-labelledby="tone-distant-parametric-eq-title"
      sx={{
        px: { xs: 3, md: 5 },
        py: { xs: 6, md: 8 },
        background: "radial-gradient(circle, #3a3a3a 0%, #1a1a1a 100%)",
        color: "#F9F5EE",
      }}
    >
      <Box sx={{ maxWidth: 1100, mx: "auto" }}>
        <Box sx={{ maxWidth: 800, mx: "auto", textAlign: "center" }}>
          <Typography id="tone-distant-parametric-eq-title" component="h2" variant="h3" sx={{ mb: 3 }}>
            Built-in Parametric EQ
          </Typography>
          <Typography component="p" variant="h6">
            Fine-tune your sound with a fully integrated parametric EQ and an easy-to-use interface.
          </Typography>
        </Box>

        <Box sx={{ my: { xs: 4, md: 5 } }}>
          <img
            src={parametricEQImage}
            alt="ToneSuite - Distant parametric EQ with frequency curves and dynamic-band controls"
            width={2746}
            height={1806}
            loading="lazy"
            decoding="async"
            style={{
              display: "block",
              width: "100%",
              height: "auto",
              borderRadius: "18px",
              boxShadow: "0 24px 60px rgba(0, 0, 0, 0.45)",
              border: "1px solid rgba(249, 245, 238, 0.12)",
              boxSizing: "border-box",
            }}
          />
        </Box>

        <Grid container spacing={{ xs: 3, md: 4 }}>
          {EQ_FEATURES.map((feature) => (
            <Grid item xs={12} md={4} key={feature.title}>
              <Typography component="h3" variant="h6" sx={{ mb: 1, fontWeight: 700 }}>
                {feature.title}
              </Typography>
              <Typography component="p" variant="h6" sx={{ color: "rgba(249, 245, 238, 0.85)" }}>
                {feature.description}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default ParametricEQ;
